"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactBarCompact = require("./ContactBarCompact");
Object.keys(_ContactBarCompact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactBarCompact[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactBarCompact[key];
    }
  });
});